import { Namespace } from 'enums-lib';
import { IRemoteFileInfo, WorkflowMessage } from 'interfaces-lib';
import { ErrorSeverity, MessageNotificationService } from 'message-notification-service-lib';
import { Subject } from 'rxjs';
import { WorkflowTask } from 'workflow-task-service-lib';

export class EditS3FileTask extends WorkflowTask {
  private resolveEditorFileLocation!: (value: IRemoteFileInfo | PromiseLike<IRemoteFileInfo>) => void;
  private rejectEditorFileLocation!: (reason?: any) => void;
  private editorFileLocationPromise = new Promise<IRemoteFileInfo>((resolve, reject) => {
    this.resolveEditorFileLocation = resolve;
    this.rejectEditorFileLocation = reject;
  });

  public documentUpdated$ = new Subject<void>();

  constructor(
    private restoreKey: string,
    private messageNotificationService: MessageNotificationService,
    private editorFileInfo: IRemoteFileInfo | undefined,
    private namespace: string,
    private sourceApplication: string,
  ) {
    super('EDIT_DOCUMENT_S3');
  }

  override getStartParams(): any {
    return {
      RESTORE_STATE: {
        key: this.restoreKey,
      },
      EDITOR_FILE: this.editorFileInfo,
      SOURCE_APPLICATION: this.sourceApplication,
    };
  }

  override receive(message: WorkflowMessage): boolean {
    if (message.type === 'ErrorEvent') {
      this.rejectEditorFileLocation();
      this.messageNotificationService.error(message.message);
      return true;
    }

    if (message.type === 'SendToEditorResponse') {
      this.resolveEditorFileLocation(message.message);
      return this.openFile(<IRemoteFileInfo>message.message);
    }

    if (message.type === 'SavedToEntity') {
      this.messageNotificationService.success('Document Updated.');
      this.documentUpdated$.next();
    }

    return false;
  }

  public asyncOpenFileResponse(): Promise<IRemoteFileInfo> {
    return this.editorFileLocationPromise;
  }

  private openFile(fileInfo: IRemoteFileInfo): boolean {
    console.log('open file', fileInfo);

    const documentUrl = `ms-word:ofe|u|${fileInfo.editorHost}${fileInfo.path}`;
    const documentWindow = this.openWord(documentUrl);

    if (!documentWindow) {
      this.messageNotificationService.error('Could not open Word.', undefined, undefined, ErrorSeverity.CRITICAL);
      return true;
    }

    return false;
  }

  openWord(documentUrl: string) {
    if (this.namespace === Namespace.salesforce) {
      if (window.top) {
        return (window.top.location.href = documentUrl);
      }
      return undefined;
    } else {
      return window.open(documentUrl, '_self');
    }
  }
}
